window.Routes = function() {
	//var pathname = window.location.pathname;

	//var path = window.location.pathname.split("/");
	var path = PAGE_ROUTE.split("/");

	// path is an array of each words of the url
	// `/foo/bar/baz` gives a path variable of ["foo", "bar", "baz"]
	
	//Stop here if route doesn't actually exist
	if(PAGE_URL == '404') {
		return;
	}

	if(path[0] === "info" && path[1] === "production-and-shipping") {
		new AOW.ShippingTables(path[1]);
	}
};
